import {
  faDashboard,
  faBox,
  faTruck,
  faBoxes,
  faSyncAlt,
  faSquareArrowUpRight,
  faSignInAlt,
  faExchangeAlt,
  faNoteSticky,
  faBoxOpen,
  faFileInvoice,
  faCartArrowDown,
  faOutdent,
  faArrowRightFromBracket,
  faTriangleExclamation,
} from '@fortawesome/free-solid-svg-icons'

export const sectionsAlmoxarifado = [
  {
    title: 'Dashboard',
    icon: faDashboard,
    to: '/dashboard',
    requiredPermission: 'Listar dashboard de almoxarifado',
  },
  {
    title: 'Produtos',
    icon: faBox,
    items: [
      {
        name: 'Produto',
        icon: faBox,
        to: '/almoxarifado/produtos',
        requiredPermission: 'Listar produtos',
      },
      {
        name: 'Marcas',
        icon: faNoteSticky,
        to: '/almoxarifado/produtos/marcas',
        requiredPermission: 'Listar marcas',
      },
      {
        name: 'Grupos',
        icon: faBoxes,
        to: '/almoxarifado/produtos/grupos',
        requiredPermission: 'Listar grupos',
      },
      {
        name: 'Tipos',
        icon: faBoxes,
        to: '/almoxarifado/produtos/tipos',
        requiredPermission: 'Listar tipos',
      },
    ],
  },
  {
    title: 'Fornecedores',
    icon: faTruck,
    items: [
      {
        name: 'Fornecedor',
        icon: faTruck,
        to: '/almoxarifado/fornecedores',
        requiredPermission: 'Listar fornecedores',
      },
    ],
  },
  {
    title: 'Transações',
    icon: faSyncAlt,
    items: [
      {
        name: 'Entrada',
        icon: faSignInAlt,
        to: '/almoxarifado/transacoes/entrada',
        requiredPermission: 'Listar transações',
      },
      {
        name: 'Transferência',
        icon: faExchangeAlt,
        to: '/almoxarifado/transacoes/transferencia',
        requiredPermission: 'Listar transações',
      },
      {
        name: 'Saída Interna',
        icon: faArrowRightFromBracket,
        to: '/almoxarifado/transacoes/saida-interna',
        requiredPermission: 'Listar transações',
      }, 
    ],
  },
  {
    title: 'Relatórios',
    icon: faSquareArrowUpRight,
    items: [
      {
        name: 'Transações',
        icon: faSignInAlt,
        to: '/almoxarifado/relatorios/transações',
        requiredPermission: 'Listar relatórios',
      },
      {
        name: 'Relatório Contábil',
        icon: faFileInvoice,
        to: '/almoxarifado/relatorios/contabil',
        requiredPermission: 'Listar relatórios',
      },
      {
        name: 'Inventário',
        icon: faBoxOpen,
        to: '/almoxarifado/relatorios/inventario',
        requiredPermission: 'Listar relatórios',
      },
      {
        name: 'Extrato de Produto',
        icon: faFileInvoice,
        to: '/almoxarifado/relatorios/extrato-de-produto',
        requiredPermission: 'Listar relatórios',
      },
      {
        name: 'Ficha de Controle de Estoque',
        icon: faCartArrowDown,
        to: '/almoxarifado/relatorios/ficha-de-estoque',
        requiredPermission: 'Listar relatórios',
      },
      {
        name: 'Consumo Mensal',
        icon: faOutdent,
        to: '/almoxarifado/relatorios/consumo-mensal',
        requiredPermission: 'Listar relatórios',
      },
      {
        name: 'Estoque Crítico',
        icon: faTriangleExclamation,
        to: '/almoxarifado/relatorios/estoque-critico',
        requiredPermission: 'Listar relatórios',
      },
    ],
  },
]
